import * as ACTIONS from '../constants/pharmaEnrollForm';

const initialState = {
  loading: false,
  error: false,
  success: {},
  step: 0,
  patientInformation: {
    firstName: '',
    lastName: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    dob: '',
    email: '',
    mobilePhoneNumber: '',
    gender: '',

    pharmacyInsurance: {
      pbmName: '',
      memberId: '',
      bin: '',
      pcn: '',
      group: '',
    },

    prescriber: {
      firstName: '',
      lastName: '',
      npi: '',
      practiceName: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
    },

    drugAnswers: {
      hasMedicare: null,
      hasMedicaid: null,
      isGovermentPaid: null,
      isAge18: null,
      hasMedicalAcknowledge: null,
      isAgree: null,
      hasAnyOtherGovermentInsurance: null,
      termAndCondAccepted: null,
      hasPermissionOptIn: null,
      hasMarketingOptIn: null,
    },
  },
};

function pharmaEnrollForm (state = initialState, action) {
  switch (action.type) {
    case ACTIONS.PHARMA_ENROLL.CHANGE_STEP:
    case ACTIONS.SUBMIT_PHARMA_ENROLL_FORM.INIT:
    case ACTIONS.SUBMIT_PHARMA_ENROLL_FORM.ERROR:
    case ACTIONS.SUBMIT_PHARMA_ENROLL_FORM.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case ACTIONS.PHARMA_ENROLL.UPDATE_PATIENT_INFO:
      return {
        ...state,
        patientInformation: {
          ...state.patientInformation,
          ...action.payload,
        },
      };
    case ACTIONS.PHARMA_ENROLL.CLEAR:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
}

export default pharmaEnrollForm;
